import { DataPointsApiResponse } from '@tableau/metrics-engine';
import { SiteUrls } from '@tableau/shared-urls';

import { IDataRoleInfo } from '../../dataRole/models/IDataRoleInfo';
import { IDataSourceInfo } from '../../datasource/models/IDataSourceInfo';
import { FlowListItemInfo } from '../../flow/models/FlowInfo';
import { ILensInfo } from '../../lens/models/ILensInfo';
import { IMetricInfo } from '../../metrics/models/IMetricInfo';
import { IPublishedConnectionInfo } from '../../publishedConnection/models/IPublishedConnectionInfo';
import { ListResult } from '../../ts/fetchers/ListResult';
import { IProjectInfo } from '../../ts/models/IProjectInfo';
import { IUserInfo } from '../../ts/models/IUserInfo';
import { IViewInfo } from '../../ts/models/IViewInfo';
import { ItemCounts } from '../../ts/ServerApi/types/IUser';
import { IWorkbookInfo } from '../../workbook/models/IWorkbookInfo';

export type NavigationItemValueType = OmniboxMenuItemType | MenuItemHeaderInfo | 'searchBox';

export type OmniboxMenuItemPlaceholder = { id: string, type: OmniBoxItemType };

export type OmniboxMenuItemType =
  IViewInfo
  | IWorkbookInfo
  | IMetricInfo
  | IDataSourceInfo
  | FlowListItemInfo
  | IProjectInfo
  | CatalogOmniboxItem
  | IUserInfoForOmni
  | IDataRoleInfo
  | ILensInfo
  | IPublishedConnectionInfoForOmni
  | OmniboxMenuItemPlaceholder;

export enum OmniBoxItemType {
  databases = 'databases',
  dataRoles = 'dataRoles',
  datasources = 'datasources',
  flows = 'flows',
  global = 'global',
  lenses = 'lenses',
  metrics = 'metrics',
  projects = 'projects',
  virtualConnections = 'virtualConnections',
  tables = 'tables',
  users = 'users',
  views = 'views',
  workbooks = 'workbooks',
  searchbox = 'searchBox',
  sectionHeader = 'sectionHeader',
  placeholder = 'placeholder',
  collections = 'collections',
  searchTermItem = 'searchTermItem',
  contentTypeItem = 'contentTypeItem',
  ownerItem = 'ownerItem'
}

export type NavigationItem = {
  sectionIndex: number;
  itemIndex: number;
  type: OmniBoxItemType;
  target: NavigationItemValueType;
  left: NavigationItemValueType | null;
  right: NavigationItemValueType | null;
  up: NavigationItemValueType | null;
  down: NavigationItemValueType | null;
  total: number;
  contentId?: string;
  countInSection: number;
  countInRow: number;
}

export interface MenuItemHeaderInfo {
  headerType: OmniBoxItemType;
}

export interface Section {
  type: OmniBoxItemType;
  list: ListResult<OmniboxMenuItemType>;
}

export interface IPublishedConnectionInfoForOmni extends IPublishedConnectionInfo {
  value?: string;
}

export interface IMetricInfoForOmni extends IMetricInfo {
  value?: string;
  response?: DataPointsApiResponse;
}

export interface IUserInfoForOmni extends IUserInfo {
  ownedItemCounts?: ItemCounts;
}

export interface CatalogOmniboxItem {
  readonly id: string;
  readonly name: string;
  readonly isCertified: boolean;
  readonly workbookCount: number;
  readonly datasourceCount: number;
}

export interface IQuickLinksContentTypes {
  name: string;
  getPath: (urls: SiteUrls) => string;
  icon: string;
}
